import { styled } from '@material-ui/core';

export const RepresentativeErrorUICanvas = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const RepresentativeErrorUIContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
  fontSize: 12,
  '& svg': {
    width: 25,
    height: 25,
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: 18,
    '& svg': {
      width: 40,
      height: 40,
    },
  },

  [theme.breakpoints.up('md')]: {
    fontSize: 24,
    '& svg': {
      width: 50,
      height: 50,
    },
  },
}));
